var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, Utils, CustomElement, Watch, ViewChild, PropertyConverters, Components, Defaults } from '@pacem/pacem-core';
//namespace Pacem.Components.UI {
let PacemProgressbarElement = class PacemProgressbarElement extends Components.PacemElement {
    constructor() {
        super('progressbar', { 'valuemin': '0%', 'valuemax': '100%', 'valuenow': '0%' });
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'percentage':
                this._bar.style.transform = `translateX(${(-100 + (val || 0))}%)`;
                this._glow.style.transform = `scaleX(${((val || 0) * .01)})`;
                let perc = Utils.leftPad(Math.floor(val), 2, '0') + '%';
                this.aria.attributes.set('valuenow', perc);
                if (Utils.isNullOrEmpty(this.caption)) {
                    this.aria.attributes.set('valuetext', this._caption.textContent = perc);
                }
                break;
            case 'caption':
                this.aria.attributes.set('valuetext', this._caption.textContent = val);
                break;
        }
    }
};
__decorate([
    ViewChild('.progressbar-bar')
], PacemProgressbarElement.prototype, "_bar", void 0);
__decorate([
    ViewChild('.progressbar-glow')
], PacemProgressbarElement.prototype, "_glow", void 0);
__decorate([
    ViewChild('.progressbar-caption')
], PacemProgressbarElement.prototype, "_caption", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemProgressbarElement.prototype, "caption", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemProgressbarElement.prototype, "percentage", void 0);
PacemProgressbarElement = __decorate([
    CustomElement({
        tagName: P + '-progressbar', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="progressbar-glow"></div>
    <div class="progressbar-track"><div class="progressbar-bar"></div></div>
    <label class="progressbar-caption"></label>`
    })
], PacemProgressbarElement);
export { PacemProgressbarElement };
